'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var aboutus = exports.aboutus = {
  background_url: 'https://dev-res.thumbr.io/images/aboutus-banner.jpg',
  title: 'Sobre Tutellus',
  our_mission: 'Nuestra misión:',
  description: 'Llevar la educación hasta el último rincón del planeta',
  our_team: 'Nuestro Equipo',
  about: JSON.stringify(['Tutellus es la plataforma colaborativa de Educación online más relevante del mundo.', 'Nuestro producto combina diseño, simplicidad y tecnología, resultando una experiencia sencilla, social y divertida.', 'Tutellus opera en la actualidad en más de 160 países, formamos una Comunidad de más de 500.000 alumnos y desarrollamos el producto desde Madrid, España.']),
  team: JSON.stringify(['mcaballero', 'jortiz', 'clopez', 'karol', 'jcalvo', 'dsevilla']),
  team_pics_base_url: 'https://lib.tutellus.com/images/team',
  mcaballero_pics: JSON.stringify(['mcaballero.jpg', 'mcaballero_hover.jpg']),
  mcaballero_name: 'Miguel Caballero',
  mcaballero_role: 'CEO',
  jortiz_pics: JSON.stringify(['sokardys.jpg', 'sokardys_hover.jpg']),
  jortiz_name: 'Javier Ortiz',
  jortiz_role: 'CTO',
  clopez_pics: JSON.stringify(['clopez.jpg', 'clopez_hover.jpg']),
  clopez_name: 'Carlos López',
  clopez_role: 'Backend Dev',
  karol_pics: JSON.stringify(['karol.jpg', 'karol_hover.jpg']),
  karol_name: 'Karolina Szymanczak',
  karol_role: 'Designer',
  jcalvo_pics: JSON.stringify(['jcalvo.jpg', 'jcalvo_hover.jpg']),
  jcalvo_name: 'Javier Calvo',
  jcalvo_role: 'Data Scientist',
  dsevilla_pics: JSON.stringify(['dsevilla.jpg', 'dsevilla_hover.jpg']),
  dsevilla_name: 'David Sevilla',
  dsevilla_role: 'Scholar',
  cofounder: 'Co-Fundador'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/aboutus.js
// module id = 692
// module chunks = 0